module.exports = __webpack_public_path__ + "static/img/006.a4c6b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/006.png
// module id = Yq06
// module chunks = 1